import { Component } from "react";

/** Keeps one failing section from blanking the whole page. */
export class SectionBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error(`[Captain's Cut] ${this.props.name || "section"} failed to render:`, error);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 text-center" data-testid={`section-error-${this.props.name || "unknown"}`}>
        <p className="font-coords text-[10px] tracking-[0.3em] text-[#D4AF37]">THE CHANNEL IS ROUGH</p>
        <p className="font-editorial italic text-base text-[#94A3B8] mt-2">This section couldn't load — please refresh in a moment.</p>
      </div>
    );
  }
}
